import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShare06 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.3261 9.50617C16.5296 9.3318 16.6313 9.24461 16.6686 9.14086C16.7013 9.0498 16.7013 8.9502 16.6686 8.85914C16.6313 8.75539 16.5296 8.6682 16.3261 8.49383L9.26719 2.44331C8.917 2.14315 8.74191 1.99306 8.59367 1.98939C8.46483 1.98619 8.34177 2.04279 8.26035 2.14269C8.16667 2.25764 8.16667 2.48825 8.16667 2.94948V6.52886C6.38777 6.84007 4.75966 7.74146 3.54976 9.09489C2.23069 10.5704 1.50103 12.48 1.5 14.4591V14.9691C2.37445 13.9157 3.46626 13.0638 4.70063 12.4716C5.78891 11.9495 6.96535 11.6403 8.16667 11.5588V15.0505C8.16667 15.5117 8.16667 15.7424 8.26035 15.8573C8.34177 15.9572 8.46483 16.0138 8.59367 16.0106C8.74191 16.0069 8.917 15.8569 9.26719 15.5567L16.3261 9.50617Z",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShare06;
